export default __webpack_public_path__ + "static/media/ISKO CLASS-5 EXAM PATTERN 2025.35146379.pdf";